/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as RiverService} from "../../../Services/RiverService";

export class RiverFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			rivers: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		RiverService.Get()
			.then((x) => {
				this.setState({rivers: x.result});
			});
	}

	@autobind
	getRiver() {
		return this.state.rivers.find((x) => x.riverId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getRiver() ? this.getRiver().name : "N/A";
	}
}